import { StrapiData } from './commons';
import { IUser } from './login';
import { Media } from './media';
import { Section } from './section';

export enum FidelityStatus {
  BOZZA = 'BOZZA',
  IN_APPROVAZIONE = 'IN_APPROVAZIONE',
  APPROVATO = 'APPROVATO',
  RIFIUTATO = 'RIFIUTATO',
  SCADUTO = 'SCADUTO',
  TERMINATO = 'TERMINATO',
}

export interface FidelityCategory {
  id?: number;
  categoria: string;
  sottocategoria?: string;
  scontoOnline: number;
  scontoNegozio: number;
}

export interface FidelityContract {
  years?: Record<string, { signedAt?: string }>;
}

export interface FidelityResponse {
  id: number;
  attributes: {
    nome: string;
    revisionNote?: string;
    ragioneSociale: string;
    indirizzo: string;
    citta: string;
    provincia: string;
    cap: string;
    latitude?: number;
    longitude?: number;
    email: string;
    telefono: string;
    telefonoSecondario?: string;
    sito?: string;
    descrizione?: string;
    partitaIva: string;
    note?: string;
    categorie: FidelityCategory[];
    socioOnav: boolean;
    numeroTessera?: number;
    stato: FidelityStatus;
    scadenzaContratto: string | null;
    contratto?: FidelityContract | null;
    inizioContratto?: number | null;
    annoUltimaApprovazione?: number | null;
    createdAt: string;
    updatedAt: string;
    sezione: {
      data: StrapiData<Section> | null;
    };
    user?: {
      data: StrapiData<IUser> | null;
    };
    immagini?: {
      data: StrapiData<Media>[];
    };
  };
}

export interface FidelityRequest {
  nome: string;
  ragioneSociale: string;
  indirizzo: string;
  citta: string;
  provincia: string;
  cap: string;
  latitude?: number | null;
  longitude?: number | null;
  email: string;
  telefono: string;
  telefonoSecondario?: string;
  sito?: string;
  descrizione?: string;
  partitaIva: string;
  note?: string;
  guidaProsit?: boolean;
  categorie: FidelityCategory[];
  socioOnav: boolean;
  numeroTessera?: number;
  stato: FidelityStatus;
  scadenzaContratto: string | null;
  contratto?: FidelityContract | null;
  inizioContratto?: number | null;
  annoUltimaApprovazione?: number | null;
  sezione: number;
  user?: number;
  revisionNote?: string;
}

export interface FidelityFilters {
  categoria?: string;
  sconto?: string;
  stato?: FidelityStatus;
  scontoOnline?: boolean;
  scontoNegozio?: boolean;
  tessera?: boolean;
  guidaProsit?: boolean;
  search?: string;
  sezione?: number;
}

export interface FidelityTableRow {
  id: number;
  tessera?: number;
  nominativo: string;
  citta: string;
  categoriaPrincipale?: string;
  scontoPrincipale?: number;
  scontoOnline: boolean;
  scontoNegozio: boolean;
  tesseraAttiva: boolean;
  guidaProsit: boolean;
  sezione: string;
  stato: FidelityStatus;
}
